import Message from '@sats-group/fresh-fitness-ui-lib/react/message';
import React from 'react';

import CampaignBanner from 'root/client/components/campaign-banner/campaign-banner';
import ContentContainer from 'root/client/components/content-container/content-container';
import InformationRow from 'root/client/components/information-row/information-row';
import MembershipCard from 'root/client/components/membership-card/membership-card';
import Toggle from 'root/client/components/toggle/toggle';

import type { CheckoutMembershipContent as Props } from './checkout-membership-content.types';

const CheckoutMembershipContent: React.FC<Props> = ({
  campaignBanner,
  information,
  memberships,
  messages,
  nextHref,
  onInteraction,
  payments,
}) => {
  const handleToggleClick =
    (hrefs: { data: string; gui: string }) =>
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (onInteraction) {
        event.preventDefault();
        onInteraction(hrefs);
      }
    };

  const handleCampaignBannerInteraction = (hrefs: {
    data: string;
    gui: string;
  }) => {
    if (onInteraction) {
      onInteraction(hrefs);
    }
  };

  const handleMembershipCardClick =
    (hrefs: { data: string; gui: string }) =>
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (onInteraction) {
        event.preventDefault();
        onInteraction({ ...hrefs, redirect: nextHref });
      }
    };

  return (
    <div className="checkout-membership-content">
      {messages.length ? (
        <div className="checkout-membership-content__group">
          {messages.map(entry => (
            <div key={entry.text}>
              <Message {...entry} />
            </div>
          ))}
        </div>
      ) : null}
      <div className="checkout-membership-content__group">
        <ContentContainer width={ContentContainer.widths.Large}>
          <div className="checkout-membership-content__discount">
            <CampaignBanner
              {...campaignBanner}
              onInteraction={handleCampaignBannerInteraction}
            />
          </div>
        </ContentContainer>
        <ContentContainer width={ContentContainer.widths.Narrow}>
          <Toggle
            label={payments.title}
            options={payments.options.map(({ api, gui, ...option }) => ({
              ...option,
              onClick: handleToggleClick({
                data: api,
                gui,
              }),
            }))}
          />
        </ContentContainer>
        <ContentContainer
          className="checkout-membership-content__options-section"
          width={ContentContainer.widths.Wide}
        >
          <div className="checkout-membership-content__options">
            {memberships.options.map(({ api, gui, id, ...membership }) => (
              <div key={id}>
                <MembershipCard
                  {...membership}
                  onClick={handleMembershipCardClick({ data: api, gui })}
                />
              </div>
            ))}
          </div>
        </ContentContainer>
        <ContentContainer width={ContentContainer.widths.Medium}>
          <div>
            {information.map(entry => (
              <InformationRow {...entry} key={entry.text} />
            ))}
          </div>
        </ContentContainer>
      </div>
    </div>
  );
};

export default CheckoutMembershipContent;
